/**
 * Vino Cammino rotating winemaker names (homepage banner heading).
 *
 * Cycles the .rotating-names span through the winemakers' first names.
 * Previously this lived appended to the theme's animations.js, which theme
 * version updates silently wiped; as a standalone asset it is carried over
 * automatically. The span itself is rendered by sections/image-banner.liquid
 * and the .rotating-names layout CSS lives in theme settings Custom CSS.
 */
(function () {
  'use strict';

  var NAMES = [
    'Alexia',
    'Anne-Laure',
    'Blandine',
    'Caterina',
    'Catherine',
    'Cecilia',
    'Elise',
    'Federica',
    'Giulia',
    'Julie',
    'Laure',
    'Marine',
    'Marjorie',
    'Sophie',
    'Stefano',
  ];
  var INTERVAL_MS = 1000;

  function init() {
    var nameSpan = document.querySelector('.rotating-names');
    if (!nameSpan) return;
    var currentIndex = 0;
    setInterval(function () {
      nameSpan.textContent = NAMES[currentIndex];
      currentIndex = (currentIndex + 1) % NAMES.length;
    }, INTERVAL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
